// extracted by mini-css-extract-plugin
export default {"spinner":"loading_spinner__9cIKf","spinner-aib1d7":"loading_spinner-aib1d7__Z1iku"};